import _ from 'lodash';
import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
/** Whether an event is still the one to emit, or kept only so old runs still read. */
export var FlowStandardAnalyticEventStatus;
(function (FlowStandardAnalyticEventStatus) {
    FlowStandardAnalyticEventStatus["Active"] = "Active";
    FlowStandardAnalyticEventStatus["Deprecated"] = "Deprecated";
})(FlowStandardAnalyticEventStatus || (FlowStandardAnalyticEventStatus = {}));
/**
 * Body `POST /standard-analytic-events` accepts.
 *
 * The name is what analytics group by, so it is held to one spelling: lowerCamelCase, long enough
 * to say what happened.
 */
export const FlowStandardAnalyticEventCreateBodySchema = z.object({
    name: z
        .string()
        .min(6)
        .refine((value) => _.camelCase(value) === value, {
        message: 'Event name must be in lowerCamelCase',
    }),
    description: z.string(),
    categoryId: z.uuid().describe('Category the event is filed under.'),
    customAttributeKeys: z
        .array(z.string())
        .describe('Attribute names a flow may attach when emitting the event.')
        .optional()
        .default([]),
    status: z.enum(FlowStandardAnalyticEventStatus).optional(),
});
/**
 * Body `PUT /standard-analytic-events/{id}` accepts: whichever fields are changing.
 *
 * `customAttributeKeys` loses its default first. A default survives `.partial()`, so an update that
 * does not mention the keys would arrive as an empty array and clear the ones the event has.
 */
export const FlowStandardAnalyticEventUpdateBodySchema = FlowStandardAnalyticEventCreateBodySchema.extend({
    customAttributeKeys: z.array(z.string()),
}).partial();
/** Query parameters `GET /standard-analytic-events` accepts. */
export const FlowStandardAnalyticEventListQuerySchema = z.object({
    q: z.string().describe('Return only events whose name or description matches this.').optional(),
    categoryId: z.uuid().describe('Return only events in this category.').optional(),
    status: z
        .enum(FlowStandardAnalyticEventStatus)
        .describe('Return only events in this status.')
        .optional(),
    limit: FlowApiPageLimitSchema.describe('How many events to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as name.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
});
/** Path parameters the endpoints addressing one event accept. */
export const FlowStandardAnalyticEventIdParamsSchema = z.object({
    id: z.string().describe('The standard analytic event.'),
});
//# sourceMappingURL=standardEvent.js.map